import Icon from 'veui/components/Icon'

Icon.register({
  'file-hourglass': {
    paths: [
      {
        d: 'M256 192a32 32 0 000 64h256a32 32 0 000-64zm97 480H160V96h448v224a32 32 0 0064 0V64a32 32 0 00-32-32H128a32 32 0 00-32 32v640a32 32 0 0032 32h225a32 32 0 000-64zm-97-320a32 32 0 000 64h128a32 32 0 000-64zm448 128v-32a32 32 0 00-32-32H480a32 32 0 00-32 32v32a127.71 127.71 0 0043.44 96A127.71 127.71 0 00448 672v32a32 32 0 0032 32h192a32 32 0 0032-32v-32a127.71 127.71 0 00-43.44-96A127.71 127.71 0 00704 480zm-64 192H512a63.93 63.93 0 0126.06-51.51A53.76 53.76 0 00560 577.28v-2.56a53.76 53.76 0 00-21.94-43.21A63.93 63.93 0 01512 480h128a63.93 63.93 0 01-26.06 51.51A53.76 53.76 0 00592 574.72v2.56a53.76 53.76 0 0021.94 43.21A63.93 63.93 0 01640 672z'
      }
    ],
    width: '768',
    height: '768'
  }
})
